import {
  getLayoutByIdApi,
  hideLoader,
  LayoutRowType,
  showLoader,
} from '@app-store'
import { useEffect, useState } from 'react'
import { EntityLayout } from '../../types/layout.types'
import CardRender from './CardRender'
import { useAppDispatch } from '../../utils/agent.store'

const View360RowRender = ({
  row,
  layout,
  // middleCard,
}: {
  row: LayoutRowType
  layout: EntityLayout
  // middleCard: boolean
}) => {
  const dispatch = useAppDispatch()
  const [cardListLayout, setCardListLayout] = useState<EntityLayout>()
  const [cardEditLayout, setCardEditLayout] = useState<EntityLayout>()
  const rowKey = row?.keyName ?? ''
  const entityId =
    layout?.layout_data?.added_fields?.[rowKey]?.d_entity_id?.toString()
  const listLayoutId =
    layout?.layout_data?.added_fields?.[rowKey]?.list_view_layout_id?.toString()
  const editLayoutId =
    layout?.layout_data?.added_fields?.[rowKey]?.create_layout_id?.toString()

  const fetchLayout = async () => {
    try {
      dispatch(showLoader())
      const responseList = await getLayoutByIdApi({
        entityId,
        layoutId: listLayoutId,
      })
      if (responseList?.data) {
        setCardListLayout(responseList?.data)
      }
      dispatch(hideLoader())
    } catch (err) {
      dispatch(hideLoader())
      console.log(err)
    }
  }

  const fetchEditLayout = async () => {
    try {
      if (editLayoutId) {
        const responseEdit = await getLayoutByIdApi({
          entityId,
          layoutId: editLayoutId,
        })
        setCardEditLayout(responseEdit?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchLayout()
    fetchEditLayout()
  }, [])

  return (
    <div className="px-5 py-5 w-full">
      <CardRender
        card={row}
        parentLayout={layout}
        cardListLayout={cardListLayout}
        cardEditLayout={cardEditLayout}
        // middleCard={middleCard} {/* TODO will review later */}
      />
    </div>
  )
}

export default View360RowRender
